"use client";

import React, { Dispatch, createContext, useReducer } from "react";
import {act} from "react-dom/test-utils";


type BetslipItem = {
    selectionId: number
    event: string
    market: string
    selection: string
    stake: number
}

type StateType = {
    betslip: BetslipItem[]
}

type ActionType = {
    type: string
    betslipItem?: BetslipItem
}

const initialState: StateType = {
    betslip: typeof window !== 'undefined' ? JSON.parse(localStorage.getItem("betslip") ?? '{}') || [] : []
}

const reducer = (state: StateType, action: ActionType) => {
    switch(action.type) {
        case "ADD":
            if (action.betslipItem) {
                state.betslip = state.betslip.filter((item) => {
                    return item.selectionId !== action.betslipItem?.selectionId;
                });
                state.betslip.push(action.betslipItem);
                localStorage.setItem('betslip', JSON.stringify(state.betslip));
            }
            return {...state};
        default:
            return {...state};
    }
}

export const BetslipContext = createContext<{
    state: StateType,
    dispatch: Dispatch<ActionType>
}>({state: initialState, dispatch: () => null});

export const BetslipContextProvider = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <BetslipContext.Provider value={{state, dispatch}}>
            {children}
        </BetslipContext.Provider>
    );
};
